interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Outline copy glyph for "Copy" actions on a shareable link. */
const FigmaLinkIcon = ({ width = 16, height = 16, color = '#708090' }: Properties) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.6667 6H7.33333C6.59695 6 6 6.59695 6 7.33333V12.6667C6 13.403 6.59695 14 7.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V7.33333C14 6.59695 13.403 6 12.6667 6Z'
      stroke={color}
      strokeWidth='1.33333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3.33337 10.0001H2.66671C2.31309 10.0001 1.97395 9.85957 1.72390 9.60953C1.47385 9.35948 1.33337 9.02034 1.33337 8.66672V3.33339C1.33337 2.97976 1.47385 2.64063 1.72390 2.39058C1.97395 2.14053 2.31309 2.00005 2.66671 2.00005H8.00004C8.35366 2.00005 8.6928 2.14053 8.94285 2.39058C9.19290 2.64063 9.33337 2.97976 9.33337 3.33339V4.00005'
      stroke={color}
      strokeWidth='1.33333'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default FigmaLinkIcon;
